<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="dataSource"
			:server-items-length="totalItens"
			item-key="id"
			no-data-text="O histórico não aparece"
			hide-default-footer
		>
			<template #item.dataCadastro="{ item }">
				<span>{{ item.dataCadastro | formatDataHourMinuteFilter }}</span>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@resetar-page="resetarPage"
			@paginar="setPaginacaoHistorico"
		></paginacao-tabela>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'historico-alteracao-fornecedor',
	components: {},
	props: {},
	data() {
		return {
			itemSelecionado: {
				type: Object,
			},
			dataSource: [],
			colunas: [
				new TabelaColunaUtils('De', 'pessoaEntityAnterior.razaoSocial', '15%'),
				new TabelaColunaUtils('Para', 'pessoaEntityAtual.razaoSocial', '15%'),
				new TabelaColunaUtils('Data', 'dataCadastro', '15%'),
				new TabelaColunaUtils('Motivo', 'justificativa', '15%'),
			],
			paginacaoInterna: PaginacaoListagem(['id'], 5, 'DESC'),
			totalPaginas: 0,
			totalItens: 0,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
	},
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	async mounted() {
		this.itemSelecionado = this.$store.state.itemAta.itemSelecionado
		this.resetarPage()
		await this.carregarHistoricos()
	},

	methods: {
		async carregarHistoricos() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.HISTORICO.BUSCAR_HISTORICOS,
				this.itemSelecionado.id,
			)
			this.dataSource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.carregando = false
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_FORNECEDOR.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_FORNECEDOR.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.carregarHistoricos()
		},
	},
}
</script>
<style lang="stylus" scoped></style>
